import { Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'
import { DisplayNameShortPipe } from './display-name-short.pipe'

@Pipe({ name: 'displayMultipleNamesShort' })
export class DisplayMultipleNamesShortPipe extends DisplayNameShortPipe implements PipeTransform {
    transform(subjects: Array<any>, trim?: number): string {
        if (subjects[0].orderName === undefined) {
            subjects = subjects.map(obj => ({ ...obj, orderName: obj.prijmeni + obj.jmeno + obj.nazev }))
            subjects = subjects.sort((a, b) => a.orderName.localeCompare(b.orderName))
        }
        let list = _.join(_.map(subjects, subject => super.transform(subject)), ', ')
        if(list.length > trim) {
            list = list.substr(0, trim - 2).trim() + '…'
        }
        return list
    }
}